import React from "react"
import {useTranslation} from "react-i18next";
import {Field} from "react-final-form";
import TextFieldWrapper from "../../Form/TextField";

const PhoneField = ()=> {
    const { t } = useTranslation()

    const validate = {
        phone: (item: string | null) => {
            if (item)
                return !new RegExp(/[0-9]{2}-?[0-9]-?[0-9]/).test(item)
                    ? t('errors.phone')
                    : ''
            return t('errors.required')
        },
    }

    return (
        <Field
            name="phone"
            type="tel"
            validate={validate.phone}
        >
            {(props) => (
                <TextFieldWrapper
                    {...props}
                    fullWidth
                    variant="outlined"
                    required
                    placeholder={t('common.phone')}
                />
            )}
        </Field>
    )
}

export default PhoneField
